module.exports = "/_next/static/images/pancake_lunch-7cf7f38685d6735bc619b08db2c42ca9.jpg";